// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/main.sass
// module id = 10
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///./resources/assets/sass/main.sass


// WEBPACK FOOTER //
// webpack:///webpack:///./resources/assets/sass/main.sass


// WEBPACK FOOTER //
// webpack:///webpack:///webpack:///./resources/assets/sass/main.sass